import { parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DialogContentWrapper from "../../../../common/components/functional/dialogs/DialogContentWrapper";
import { Nullable } from "../../../../common/types/nullable";
import { AccumulationsForEmploymentResponse } from "../../../employment/employmentApi";
import Accumulations from "./Accumulations";

type Props = {
  closeEditingModal: () => void;
  dateRange: [Nullable<string>, Nullable<string>];
  continuousEmploymentId?: string;
};

export const getHeaderColumns = (
  tableData: AccumulationsForEmploymentResponse,
) => {
  return {
    keys: tableData?.meta?.keys,
    stateNames: tableData?.meta?.stateNames,
  };
};

const AccumulationsModal = ({
  closeEditingModal,
  dateRange,
  continuousEmploymentId,
}: Props) => {
  const [edit, setEdit] = useState(false);
  const [editDisabled, setEditDisabled] = useState(true);

  const { t } = useTranslation();

  const [startDateString, endDateString] = dateRange;

  const methods = useForm({
    defaultValues: {
      accumulation: "",
      dateFrom: startDateString ? parseISO(startDateString) : null,
      dateTo: endDateString ? parseISO(endDateString) : null,
    },
    mode: "onChange",
  });

  useEffect(() => {
    methods.trigger();
  }, [methods]);

  const onEdit = () => setEdit(true);
  const onClose = () => setEdit(false);
  const onCancel = () => closeEditingModal();

  return (
    <FormProvider {...methods}>
      <DialogContentWrapper title={t("talentProfile:accumulations")} margin>
        <Accumulations
          accumulationType="continuousEmployment"
          onClose={onClose}
          edit={edit}
          onEdit={onEdit}
          onCancel={onCancel}
          tableProps={{ sx: { maxHeight: "500px" } }}
          setEditDisabled={setEditDisabled}
          editDisabled={editDisabled}
          xs={[3, 9]}
          continuousEmploymentId={continuousEmploymentId}
        />
      </DialogContentWrapper>
    </FormProvider>
  );
};

export default AccumulationsModal;
